<template>
  <v-fade-transition>
    <v-chip
      v-if="isOnline"
      small
      text-color="green darken-4"
      color="green lighten-4"
      class="font-weight-bold online-chip"
    >
      <v-icon left small color="green darken-3">mdi-circle</v-icon>
      Online
    </v-chip>
  </v-fade-transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    ...mapGetters("global", ["onlineUserIds"]),
    isOnline() {
      const ids = this.onlineUserIds.map((id) => String(id));
      return ids.includes(String(this.userId));
    },
  },
};
</script>

<style scoped>
.online-chip {
  position: relative;
  animation: pulse 2s infinite ease-in-out;
  box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
  transition: box-shadow 0.3s ease;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(76, 175, 80, 0.1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.4);
  }
}
</style>